import React from 'react';
import Modal from 'react-bootstrap/Modal';

// Services & Helpers
import FormHelper from 'helpers/FormHelper';
import API from 'API';

// Components
import Loader from 'components/common/Loader';

//-----------------------------------------------------------------

class EditRoutingProfileModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.form = new FormHelper({
            fields: {
                name: {
                    label: 'Name',
                    type: 'text'
                },
                autoSwitchMonth: {
                    label: 'Automatically switch to this profile in...',
                    type: 'single-select',
                    blankText: '(None)',
                    getOptions: () => [
                        { text: 'Jan', value: 1 },
                        { text: 'Feb', value: 2 },
                        { text: 'Mar', value: 3 },
                        { text: 'Apr', value: 4 },
                        { text: 'May', value: 5 },
                        { text: 'Jun', value: 6 },
                        { text: 'Jul', value: 7 },
                        { text: 'Aug', value: 8 },
                        { text: 'Sep', value: 9 },
                        { text: 'Oct', value: 10 },
                        { text: 'Nov', value: 11 },
                        { text: 'Dec', value: 12 }
                    ]
                },
                travelTimeGreen: {
                    label: 'Map - lines show green when travel time X minutes or under',
                    type: 'number'
                },
                travelTimeRed: {
                    label: 'Red when X minutes or over',
                    type: 'number'
                },
                showTravelTime: {
                    boxLabel: 'Show a block for travel time on the Day Sheet',
                    type: 'checkbox'
                },
                showTravelTimeAfterXMins: {
                    label: 'Show a block for travel time if at least X minutes',
                    type: 'number'
                },
                showWarningOverXMins: {
                    label: 'Show a warning if selected time adds X minutes or more to total travel time',
                    type: 'number'
                },
                costPerDay: {
                    label: 'Cost for booking into the future (per day)',
                    type: 'number'
                },
                emptyDayPenalty: {
                    label: 'Cost penalty for booking on an empty day',
                    type: 'number'
                },
                travelTimeCost: {
                    label: 'Travel cost (per minute)',
                    type: 'number'
                },
                redTravelTimePenalty: {
                    label: 'Cost penalty for Red travel time',
                    type: 'number'
                },
                gapCost: {
                    label: 'Cost penalty for gap caused between appointments (per minute)',
                    type: 'number'
                },
                maxCostBandA: {
                    label: 'Maximum cost for Great',
                    type: 'number'
                },
                maxCostBandB: {
                    label: 'Maximum cost for Good',
                    type: 'number'
                },
                maxCostBandC: {
                    label: () =>
                        'Maximum cost for OK (non-empty day)' + (this.props.account.isOnlineBookingEnabled ?
                            ' (if used for Online Booking, this is the threshold for whether a slot can be booked)' :
                            ''
                        ),
                    type: 'number'
                },
                maxCostBandCEmptyDay: {
                    label: () =>
                        'Maximum cost for OK (empty day)' + (this.props.account.isOnlineBookingEnabled ?
                            ' (if used for Online Booking, this is the threshold for whether a slot can be booked)' :
                            ''
                        ),
                    type: 'number'
                },
                maxTravelTime: {
                    label: 'Don\'t allow any routes that go over X mins travel time (non-empty day)',
                    type: 'number',
                    min: 0
                },
                maxTravelTimeEmptyDay: {
                    label: 'Don\'t allow any routes that go over X mins travel time (empty day)',
                    type: 'number',
                    min: 0
                },
                numDaysAheadForFutureCost: {
                    label: 'Cost for future booking only applies after X days',
                    type: 'number'
                },
                normaliseSuggestions: {
                    boxLabel: 'Normalise suggestions (gives results more often, although this may include worse suggestions)',
                    type: 'checkbox'
                },
                useSimplifiedLookup: {
                    boxLabel: 'Use simplified distance lookup (slightly reduces quality of results but is a LOT quicker)',
                    type: 'checkbox'
                }
            },
            getValue: (fieldName) => this.getFieldValue(fieldName),
            setValue: (fieldName, value) => this.updateFields({ [fieldName]: value })
        });
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                id: null,
                ...opt
            }, () => {
                this.load();
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async load() {
        const {
            id
        } = this.state;

        // Load routing profile
        let routingProfile;
        if (id) {
            routingProfile = await API.call('auto-planner/get-profile/' + id);
        } else {
            routingProfile = {
                useSimplifiedLookup: true
            };
        }

        // Update
        this.setState({
            routingProfile,
            isLoading: false
        });
    }
    
    getFieldValue(fieldName) {
        return this.state.routingProfile[fieldName];
    }

    updateFields(fields) {
        const routingProfile = { ...this.state.routingProfile };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            routingProfile[fieldName] = value;
        }
        this.setState({ routingProfile });
    }

    async saveAndClose() {
        this.setState({ isLoading: true });
        try {
            await API.call('auto-planner/save-profile', this.state.routingProfile);
            this.close();
            this.resolve();
        } catch (error) {
            alert(error);
            this.setState({ isLoading: false });
        }
    }

    async confirmDelete() {
        const confirm = window.confirm('Are you sure you want to delete this profile?');
        if (confirm) {
            this.setState({ isLoading: true });
            await API.call('auto-planner/delete-profile/' + this.state.id);
            this.close();
            this.resolve();
        }
    }

    async confirmDuplicate() {
        const confirm = window.confirm('Are you sure you want to duplicate this profile?');
        if (confirm) {
            this.setState({ isLoading: true });
            const { id } = await API.call('auto-planner/duplicate-profile/' + this.state.id);
            this.setState({
                id
            }, () => {
                this.load();
            });
        }
    }

    render() {
        const { 
            isOpen,
            isLoading,
            id,
            routingProfile
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show onHide={() => this.close()} className="edit-routing-profile-modal" backdrop="static" keyboard={false}>
                {isLoading ?
                    <Modal.Body><Loader /></Modal.Body> :
                    <form onSubmit={e => { this.saveAndClose(); e.preventDefault() }}>
                        <Modal.Header closeButton>
                            <Modal.Title>{routingProfile.name || 'New Profile'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            {this.renderInner()}

                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={() => this.close()}>
                                Cancel
                            </button>
                            {!!id && <>
                                <button type="button" className="btn btn-secondary" onClick={() => this.confirmDelete()}>
                                    Delete
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.confirmDuplicate()}>
                                    Duplicate
                                </button>
                            </>}
                            <button type="submit" className="btn btn-primary ms-auto">
                                Save Changes
                            </button>
                        </Modal.Footer>
                    </form>
                }
            </Modal>
        );
    }

    renderInner() {
        const { routingProfile, account } = this.state;

        return (<>

            <fieldset>
                {this.form.render([
                    'name',
                    'autoSwitchMonth',
                    'costPerDay',
                    'numDaysAheadForFutureCost',
                    'emptyDayPenalty',
                    'travelTimeCost',
                    'redTravelTimePenalty',
                    'gapCost',
                    'maxCostBandA',
                    'maxCostBandB',
                    'maxCostBandC',
                    'maxCostBandCEmptyDay',
                    'useSimplifiedLookup',
                    'normaliseSuggestions',
                    'travelTimeGreen',
                    'travelTimeRed',
                    'maxTravelTime',
                    'maxTravelTimeEmptyDay',
                    'showTravelTime',
                    routingProfile.showTravelTime && 'showTravelTimeAfterXMins',
                    'showWarningOverXMins'
                ])}

            </fieldset>

        </>);
    }
}

export default EditRoutingProfileModal;